import React, { ReactNode, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';

import { getStoredLocale, Locale, messages, setStoredLocale } from '../i18n';

interface IntlProviderProps {
  children: ReactNode;
}

export const IntlContext = React.createContext<{
  locale: Locale;
  setLocale: (locale: Locale) => void;
}>({
  locale: 'en',
  setLocale: () => {},
});

export default function IntlProvider({ children }: IntlProviderProps) {
  const [locale, setLocale] = useState<Locale>(getStoredLocale());

  const handleSetLocale = (newLocale: Locale) => {
    setLocale(newLocale);
    setStoredLocale(newLocale);
  };

  return (
    <IntlContext.Provider value={{ locale, setLocale: handleSetLocale }}>
      <ReactIntlProvider messages={messages[locale]} locale={locale} defaultLocale="en">
        {children}
      </ReactIntlProvider>
    </IntlContext.Provider>
  );
}
